var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceFloorLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 651.4 47.8",
    style: {
      enableBackground: "new 0 0 651.4 47.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#006D7F;}\n\t.st1{fill:#003E4C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000182504219777550222810000018172375190508952704_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M596,41.3H107.9c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5H596c1.9,0,3.5,1.6,3.5,3.5S598,41.3,596,41.3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,41.2V19.9h6.3c1.3,0,2.3,0.2,3.1,0.7s1.4,1.2,1.8,2.1c0.4,0.9,0.6,2,0.6,3.3c0,1.4-0.2,2.5-0.7,3.4 s-1.1,1.5-2,1.9s-1.9,0.6-3,0.6h-2.1v9.5h-4V41.2z M26.7,29h1.5c0.7,0,1.3-0.1,1.6-0.3c0.3-0.2,0.7-0.5,0.8-1s0.2-1,0.2-1.8 s-0.1-1.4-0.2-1.9c-0.1-0.5-0.4-0.8-0.7-1.1c-0.4-0.2-1-0.3-1.8-0.3h-1.5L26.7,29L26.7,29z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44,41.5v-13h-1.7v-2.6H44v-1c0-0.9,0.1-1.8,0.3-2.4c0.2-0.7,0.5-1.2,1.1-1.6c0.5-0.4,1.4-0.6,2.5-0.6 c0.3,0,0.7,0,1,0s0.6,0.1,1,0.1v2.7c-0.1,0-0.3-0.1-0.5-0.1c-0.2,0-0.4,0-0.5,0c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.2,0.7-0.2,1.2 v1.3h2.2v2.6h-2.2v13H44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53,41.5V19.6h3.6v21.9H53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.7,41.7c-1.1,0-2.1-0.2-2.8-0.6s-1.3-1-1.7-1.8c-0.4-0.8-0.6-1.8-0.6-2.9V31c0-1.2,0.2-2.1,0.6-2.9 c0.4-0.8,0.9-1.4,1.7-1.8c0.7-0.4,1.7-0.6,2.8-0.6c1.1,0,2.1,0.2,2.8,0.6c0.7,0.4,1.3,1,1.7,1.8c0.4,0.8,0.6,1.8,0.6,2.9v5.2 c0,1.2-0.2,2.1-0.6,2.9c-0.4,0.8-0.9,1.4-1.7,1.8C66.8,41.5,65.9,41.7,64.7,41.7z M64.8,39.2c0.4,0,0.7-0.1,0.9-0.4 c0.2-0.2,0.3-0.6,0.4-1c0.1-0.4,0.1-0.9,0.1-1.3v-5.7c0-0.5,0-0.9-0.1-1.3c-0.1-0.4-0.2-0.7-0.4-1c-0.2-0.2-0.5-0.4-0.9-0.4 s-0.7,0.1-0.9,0.4c-0.2,0.2-0.3,0.6-0.4,1c-0.1,0.4-0.1,0.8-0.1,1.3v5.7c0,0.5,0,0.9,0.1,1.3c0.1,0.4,0.2,0.7,0.4,1 C64,39.1,64.3,39.2,64.8,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.4,41.7c-1.1,0-2.1-0.2-2.8-0.6s-1.3-1-1.7-1.8c-0.4-0.8-0.6-1.8-0.6-2.9V31c0-1.2,0.2-2.1,0.6-2.9 c0.4-0.8,0.9-1.4,1.7-1.8c0.7-0.4,1.7-0.6,2.8-0.6c1.1,0,2.1,0.2,2.8,0.6c0.7,0.4,1.3,1,1.7,1.8c0.4,0.8,0.6,1.8,0.6,2.9v5.2 c0,1.2-0.2,2.1-0.6,2.9c-0.4,0.8-0.9,1.4-1.7,1.8C79.5,41.5,78.5,41.7,77.4,41.7z M77.4,39.2c0.4,0,0.7-0.1,0.9-0.4 c0.2-0.2,0.3-0.6,0.4-1c0.1-0.4,0.1-0.9,0.1-1.3v-5.7c0-0.5,0-0.9-0.1-1.3c-0.1-0.4-0.2-0.7-0.4-1c-0.2-0.2-0.5-0.4-0.9-0.4 s-0.7,0.1-0.9,0.4s-0.3,0.6-0.4,1c-0.1,0.4-0.1,0.8-0.1,1.3v5.7c0,0.5,0,0.9,0.1,1.3c0.1,0.4,0.2,0.7,0.4,1 C76.7,39.1,77,39.2,77.4,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.5,41.5V25.9h3.7v2.4c0.5-0.9,1.1-1.6,1.6-2s1.1-0.6,1.8-0.6c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0v3.8 c-0.2-0.1-0.5-0.2-0.7-0.2c-0.3-0.1-0.5-0.1-0.8-0.1c-0.5,0-0.9,0.1-1.3,0.4c-0.4,0.2-0.8,0.6-1.1,1.2v10.7H85.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceFloorLine);
export default __webpack_public_path__ + "static/media/Price-floorLine.0884ea0454cb9c2c18f9b61f9d2084ac.svg";
export { ForwardRef as ReactComponent };